import {registerNode} from "@cm/graph-v2-final"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/generate-weight-mask/definition"
import {ImageOpTilingGenerateWeightMaskHal} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/generate-weight-mask/hal"

@registerNode
export class ImageOpNodeTilingGenerateWeightMask extends BasicSpecializingImageOpNode<typeof definition, ImageOpTilingGenerateWeightMaskHal> {
    static nodeClass = "ImageOpNodeTilingGenerateWeightMask"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpTilingGenerateWeightMaskHal, parameters)
    }
}
